//todo: доработать

import { ThemeButton } from '@shared/ui/buttons';
import { useWithdrawDialog } from '@utils/dialogs-hooks';
import { useTranslation } from 'react-i18next';

export default function WithdrawBalanceBtn() {
  const { openWithdrawDialog } = useWithdrawDialog();
  const { t } = useTranslation();

  return (
    <div></div>
    // <ThemeButton
    //   appearance="secondary"
    //   startIcon="arrow-down"
    //   onClick={openWithdrawDialog}
    //   block={false}
    // >
    //   {t('withdraw_balance')}
    // </ThemeButton>
  );
}
